var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('small',{staticClass:"pad-left-half",attrs:{"title":_vm.$t('protected-super-admin-only').toString()}},[_c('b-icon',{attrs:{"icon":"shield-shaded"}})],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }